import * as yup from "yup";

	export const getEditLeadValidationSchema = ({ lead, activeLeadEmails, nonActiveLeadEmails }: any) => (
		{
			addEmail2: yup.boolean(),
			email: yup
				.string()
				.email("Invalid email.")
				.required("Email is required.")
				.test(
					"check-for-existing-active-email",
					"A lead with that email already exists.",
					(email) => {
						let pass = true;
						if (!lead || lead.email !== email) {
							if (email && activeLeadEmails.includes(email)) {
								pass = false;
							}
						}
						return pass;
					}
				)
				.test(
					"check-for-existing-non-active-email",
					"A deleted or inactive lead with that email already exists. You can reactivate that lead.",
					(email) => {
						let pass = true;
						if (!lead || lead.email !== email) {
							if (email && nonActiveLeadEmails.includes(email)) {
								pass = false;
							}
						}
						return pass;
					}
				),
			email2: yup.string().when("addEmail2", {
				is: true,
				then: yup.string().email("Invalid email."),
			}),
		}
	);
	
	export const getCreateLeadValidationSchema = ({ activeLeadEmails, nonActiveLeadEmails }: any) => (
		{
				addEmail2: yup.boolean(),
				email: yup
					.string()
					.email("Invalid email.")
					.required("Email is required.")
					.test(
						"check-for-existing-active-email",
						"A lead with that email already exists.",
						(email) => {
							let pass = true;
							if (email && activeLeadEmails.includes(email)) {
								pass = false;
							}
							return pass;
						}
					)
					.test(
						"check-for-existing-non-active-email",
						"A deleted or inactive lead with that email already exists. You can reactivate that lead.",
						(email) => {
							let pass = true;
							if (email && nonActiveLeadEmails.includes(email)) {
								pass = false;
							}
							return pass;
						}
					),
				email2: yup.string().when("addEmail2", {
					is: true,
					then: yup
						.string()
						.email("Invalid email.")
						.test(
							"check-for-existing-active-email2",
							"A lead with that email already exists.",
							(email) => {
								let pass = true;
								if (email && activeLeadEmails.includes(email)) {
									pass = false;
								}
								return pass;
							}
						)
						.test(
							"check-for-existing-non-active-email2",
							"A deleted or inactive lead with that email already exists. You can reactivate that lead.",
							(email) => {
								let pass = true;
								if (email && nonActiveLeadEmails.includes(email)) {
									pass = false;
								}
								return pass;
							}
						),
				}),
			}
	)
